import { ReactQueryDevtoolsPanel } from '@vrplatform/data';
import { useQueryDevTools } from '../hooks';

export const QueryDevTools = () => {
  const { queryDevTools } = useQueryDevTools();

  if (!queryDevTools) return null;

  return (
    <ReactQueryDevtoolsPanel
      style={{
        bottom: 0,
        position: 'fixed',
        right: 0,
        left: 0,
        zIndex: 1000,
      }}
    />
  );
};
